import React from "react";
import TextInfo from "@/bit/components/components.text";
import dynamic from "next/dynamic";
import getColor from "@gcloud-npm/utils.enums.colors";

const CustomLink = dynamic(() =>
  import("@/bit/components/components.custom-link")
);
const SimpleCard = (props) => {
  return (
    <>
      <div className="card simple-card">
        <div className="simple-card_title">
          {props["Text-1"] && props["Text-1"].text && (
            <TextInfo
              {...props["Text-1"]}
              className="text-content"
              size="t7"
              cyData={`SimpleCard Text-1`}
            />
          )}
        </div>
        <div className="simple-card_description">
          {props["Text-2"] && props["Text-2"].text && (
            <TextInfo
              {...props["Text-2"]}
              size="body2"
              className="text-content"
              cyData={`SimpleCard Text-2`}
            />
          )}
        </div>
        {props["CustomLink-1"] &&
          (props["CustomLink-1"].href || props["CustomLink-1"].onClick) && (
            <CustomLink
              {...props["CustomLink-1"]}
              title={props["CustomLink-1"].title || ""}
              taggingInfo={{
                componentName: "simple-card",
                componentContent: props["CustomLink-1"].title,
                componentVariation: "all",
                eventType: "click",
              }}
              className="card-clickable"
              cyData="Card CustomLink-1"
            />
          )}
      </div>
      <style jsx>{`
        .simple-card {
          border-radius: 16px;
          border: 1px solid ${getColor("GREY2")};
          opacity: 1;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          gap: 0.7rem;
          width: auto;
          height: 131px;
          padding: 1rem;

          :global(.card-clickable) {
            border-radius: inherit;
            &:hover {
              border: 1px solid ${getColor("GREY2")};
            }
          }
        }
      `}</style>
    </>
  );
};

export default SimpleCard;
